export function readSecureCardNumberText(cardNumberElement) {
    return (cardNumberElement?.textContent ?? '').replaceAll('\u00A0', ' ').trim();
}
export function isSecureCardNumberFilled(cardNumberElement) {
    return readSecureCardNumberText(cardNumberElement).length > 0;
}
